module.exports = __webpack_public_path__ + "static/img/chakanjietu2.8d1babd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/chakanjietu2.png
// module id = hx5u
// module chunks = 24